import React from 'react';
import './OtpInput.css';

class OtpInput extends React.Component {
    constructor(props) {
        super(props);
        const length = props.length || 6;
        this.state = {
            otp: new Array(length).fill('')
        };
        this.inputRefs = [];
    }

    componentDidUpdate(prevProps) {
        // Update internal state when value prop changes
        if (this.props.value !== prevProps.value) {
            const value = this.props.value || '';
            const length = this.props.length || 6;
            const otpArray = value.split('').slice(0, length);
            while (otpArray.length < length) {
                otpArray.push('');
            }
            this.setState({ otp: otpArray });
        }
    }

    handleChange = (index, e) => {
        const val = e.target.value;

        // Only allow digits
        if (val && !/^\d$/.test(val)) return;

        const newOtp = [...this.state.otp];
        newOtp[index] = val;
        this.setState({ otp: newOtp });

        // Call onChange callback with complete OTP
        if (this.props.onChange) {
            this.props.onChange(newOtp.join(''));
        }

        // Auto focus next input
        const length = this.props.length || 6;
        if (val && index < length - 1) {
            if (this.inputRefs[index + 1]) {
                this.inputRefs[index + 1].focus();
            }
        }
    }

    handleKeyDown = (index, e) => {
        const length = this.props.length || 6;
        const otp = this.state.otp;

        // Handle backspace
        if (e.key === 'Backspace') {
            if (!otp[index] && index > 0) {
                // If current box is empty, move to previous and clear it
                const newOtp = [...otp];
                newOtp[index - 1] = '';
                this.setState({ otp: newOtp });
                if (this.inputRefs[index - 1]) {
                    this.inputRefs[index - 1].focus();
                }

                if (this.props.onChange) {
                    this.props.onChange(newOtp.join(''));
                }
            } else if (otp[index]) {
                // If current box has value, just clear it
                const newOtp = [...otp];
                newOtp[index] = '';
                this.setState({ otp: newOtp });

                if (this.props.onChange) {
                    this.props.onChange(newOtp.join(''));
                }
            }
        }
        // Handle left arrow
        else if (e.key === 'ArrowLeft' && index > 0) {
            if (this.inputRefs[index - 1]) {
                this.inputRefs[index - 1].focus();
            }
        }
        // Handle right arrow
        else if (e.key === 'ArrowRight' && index < length - 1) {
            if (this.inputRefs[index + 1]) {
                this.inputRefs[index + 1].focus();
            }
        }
    }

    handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text/plain');
        const length = this.props.length || 6;

        // Only allow digits
        const digits = pasteData.replace(/\D/g, '').slice(0, length);

        if (digits) {
            const newOtp = digits.split('');
            while (newOtp.length < length) {
                newOtp.push('');
            }
            this.setState({ otp: newOtp });

            if (this.props.onChange) {
                this.props.onChange(newOtp.join(''));
            }

            // Focus on the next empty box or last box
            const nextIndex = Math.min(digits.length, length - 1);
            if (this.inputRefs[nextIndex]) {
                this.inputRefs[nextIndex].focus();
            }
        }
    }

    handleFocus = (index) => {
        // Select the content on focus for easy replacement
        if (this.inputRefs[index]) {
            this.inputRefs[index].select();
        }
    }

    render() {
        const length = this.props.length || 6;
        const otp = this.state.otp;

        return (
            <div className="otp-input-container">
                {otp.map((digit, index) => (
                    <input
                        key={index}
                        ref={(el) => (this.inputRefs[index] = el)}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => this.handleChange(index, e)}
                        onKeyDown={(e) => this.handleKeyDown(index, e)}
                        onPaste={this.handlePaste}
                        onFocus={() => this.handleFocus(index)}
                        className="otp-input-box"
                        autoComplete="off"
                    />
                ))}
            </div>
        );
    }
}

export default OtpInput;
